import classNames from 'classnames'
import {ClearIcon, HelpIcon, JsonIcon, PlayIconV2, PreviewIcon} from '../../../icons'
import {ImgButton, SimpleBlueButton} from '../../core/button'
import Tooltip from '../../core/tooltip'

const PhoneCallActionBar = ({
    text,
    isDarkMode,
    isPreviewMode,
    isLoadingAudio,
    onToggleVariables,
    onReset,
    onTogglePreview,
    onPlayVoice,
    isDisabled
}) => (
    <span className={classNames('phone-call-actions', {dark: isDarkMode})}>
        <span className="action-bar">
            <ImgButton onClick={onToggleVariables} type="button" disabled={isDisabled}>
                <JsonIcon className="json-icon" />
            </ImgButton>

            <ImgButton onClick={onReset} type="button" disabled={isDisabled}>
                <ClearIcon className="clear-icon" />
            </ImgButton>

            <Tooltip placement="left" trigger="click" content={text.actions_info_text}>
                <HelpIcon />
            </Tooltip>
        </span>

        <span className="action-bar">
            <SimpleBlueButton
                className={classNames('listen-button', {'preview-active': isPreviewMode})}
                type="button"
                onClick={onTogglePreview}
                disabled={isDisabled}
            >
                <PreviewIcon />
                {text.preview}
            </SimpleBlueButton>

            <SimpleBlueButton
                className="listen-button"
                type="button"
                onClick={onPlayVoice}
                disabled={isLoadingAudio || isDisabled}
            >
                <PlayIconV2 />
                {text.generate}
            </SimpleBlueButton>
        </span>
    </span>
)

export default PhoneCallActionBar
